import React from "react";
import { Icon } from "@qgiv/core-react";

/**
 * @param {object} props
 * @param {Function} props.handleCancelButton
 * @param {Function} props.combinedKeyHandlers
 * @returns {React.JSX.Element}
 */
const SearchResultsCancelButton = ({
    handleCancelButton,
    combinedKeyHandlers,
}) => (
    <button
        className="gift-matching__result -cursor--pointer"
        tabIndex={0}
        onClick={(e) => handleCancelButton(e)}
        onKeyDown={(e) => combinedKeyHandlers(e)}
        id="search-results-cancel"
        type="button"
    >
        <div className="gift-matching__result--container">
            <Icon glyph="ban-regular" type="FontAwesome" ariaHidden={false} />
            <span>
                None of these are my company. Clear entered text and search
                again.
            </span>
        </div>
    </button>
);

export default SearchResultsCancelButton;
